<template>
    <div class="library">
        <Header @cart-ref="setCartRef" />
        <div id="loading-overlay" v-if="loading">
            <img src="../assets/gifs/loading.gif" alt="Carregando" class="loading-gif">
        </div>
        <div class="main-content" v-show="!loading">
            <div class="library-container">
                <div class="header-search">
                    <Search @filtro-atualizado="atualizarFiltro" />
                </div>
                <h2 class="title-library"><i class="fa-solid fa-book-open"></i> Biblioteca</h2>

                <div class="course-category">
                    <CourseCategories @category-selected="handleCategorySelected"
                        @alphabetic-order-changed="handleAlphabeticOrder" />
                </div>
                <h3 v-if="selectedCategory" class="category-title">
                    {{ selectedCategory.nome_grupo }}
                </h3>
                <div class="pdf-grid">
                    <CardDiscipline v-for="pdf in paginatedPdfs" :key="pdf._uniqueId" :discipline="pdf"
                        @view-discipline="visualizarDisciplina" @add-to-cart="addToCart" />
                </div>
                <div class="pagination" v-if="totalPages > 1">
                    <button @click="currentPage--" :disabled="currentPage === 1">
                        <i class="fa-solid fa-chevron-left"></i>
                    </button>

                    <button v-if="currentPage > 3" @click="currentPage = 1">
                        1
                    </button>

                    <span v-if="currentPage > 4">...</span>

                    <button v-for="page in visiblePages" :key="page" @click="currentPage = page"
                        :class="{ active: currentPage === page }">
                        {{ page }}
                    </button>

                    <span v-if="currentPage < totalPages - 3">...</span>

                    <button v-if="currentPage < totalPages - 2" @click="currentPage = totalPages">
                        {{ totalPages }}
                    </button>

                    <button @click="currentPage++" :disabled="currentPage === totalPages">
                        <i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '../styles/Library.css';
import '../styles/CardDiscipline.css';
import Header from '../components/Header.vue';
import CardDiscipline from '../components/CardDiscipline.vue';
import CourseCategories from '../components/CourseCategories.vue';
import request from '../router/request';
import Search from '../components/Search.vue';

export default {
    name: 'LibraryView',
    components: {
        Header,
        CourseCategories,
        CardDiscipline,
        Search
    },
    data() {
        return {
            filtroArea: '',
            listaArea: [],
            pdfs: [],
            selectedBook: null,
            objetoVisualizar: {},
            viewDoc: '',
            pdfLista: [],
            currentPDF: 0,
            showModal: false,
            loading: true,
            carregandoCursos: false,
            search: '',
            selectedCategory: null,
            isAlphabetic: true,
            cartComponent: null,
            currentPage: 1,
            itemsPerPage: 66,

        };
    },

    methods: {
        atualizarFiltro(filtro) {
            this.search = filtro.texto;
            this.filtroArea = filtro.area;
            this.currentPage = 1;
        },

        handleCategorySelected(category) {
            this.selectedCategory = category;
            this.currentPage = 1;
        },

        handleAlphabeticOrder(isAlphabetic) {
            this.isAlphabetic = isAlphabetic;
            this.currentPage = 1;
        },
        visualizarDisciplina(discipline) {
            console.log('Visualizar disciplina:', discipline);

        },
        addToCart(discipline) {
            console.log('Adicionar ao carrinho:', discipline);
            if (this.cartComponent) {
                this.cartComponent.addToCart(discipline);
            }
        },
        setCartRef(cartRef) {
            this.cartComponent = cartRef;
        },
        carregarCursos(formulario, filtro) {
            var self = this;
            self.carregandoCursos = true;
            if (formulario.codigo_cpa_formulario) {
                request.post(`ava/listarBiblVirtual/`, filtro, self, function (response) {
                    self.listaCursos = response.data;
                    self.carregandoCursos = false;
                });
            }
        },
    },
    computed: {
        filteredPdfs() {
            if (!Array.isArray(this.pdfs)) return [];

            let filtered = this.pdfs.filter(pdf => {
                const nomeMatch = !this.search || pdf.nome_disciplina.toLowerCase().includes(this.search.toLowerCase());
                const areaMatch = !this.filtroArea || pdf.codigo_grupo == this.filtroArea;
                const categoryMatch = !this.selectedCategory || pdf.codigo_grupo == this.selectedCategory.codigo_grupo;

                return nomeMatch && areaMatch && categoryMatch;
            });

            filtered.sort((a, b) =>
                this.isAlphabetic
                    ? a.nome_disciplina.localeCompare(b.nome_disciplina)
                    : b.nome_disciplina.localeCompare(a.nome_disciplina)
            );

            return filtered;
        },

        paginatedPdfs() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredPdfs.slice(start, end);
        },

        totalPages() {
            return Math.ceil(this.filteredPdfs.length / this.itemsPerPage);
        },

        visiblePages() {
            const total = this.totalPages;
            const current = this.currentPage;
            const range = 2;

            let start = Math.max(1, current - range);
            let end = Math.min(total, current + range);

            if (current <= range + 1) {
                start = 1;
                end = Math.min(total, 1 + range * 2);
            }

            if (current + range >= total) {
                start = Math.max(1, total - range * 2);
                end = total;
            }

            const pages = [];
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        }
    },
    mounted() {
        window.scrollTo(0, 0);

        request.post('ava/listarBiblVirtual')
            .then(response => {
                const resultado = response.data;

                let lista = [];
                if (Array.isArray(resultado)) {
                    lista = resultado;
                } else if (Array.isArray(resultado.data)) {
                    lista = resultado.data;
                } else {
                    // console.warn('Resposta inesperada para listarBiblVirtual:', resultado);
                }

                const codigos = lista.map(p => p.codigo_disciplina);
                const duplicados = codigos.filter((item, index) => codigos.indexOf(item) !== index);
                if (duplicados.length > 0) {
                    // console.warn("⚠️ Chaves duplicadas detectadas:", duplicados);
                }

                this.pdfs = lista.map((pdf, index) => ({
                    ...pdf,
                    _uniqueId: pdf.codigo_disciplina + '-' + index
                }));

            })
            .catch(err => {
                console.error('Erro ao carregar livros:', err);
                this.pdfs = [];
            })
            .finally(() => {
                this.loading = false;
            });
    },
};
</script>
